import { segment } from '@actions/analytics';
import { useRouter } from 'next/router';
import { getPlusSubscriptionInfo } from '@selectors/subscription';
import { useSelector } from 'react-redux';

const useCombatSegmentAnalytics = () => {
  const router = useRouter();
  const { query } = router;

  const {
    subscription = {},
    expired_at,
    time_remaining
  } = useSelector(getPlusSubscriptionInfo(query.goalUID)) ?? {};

  return (actionKey, additionalProps = {}) => {
    segment.track(actionKey, {
      goal_uid: query.goalUID,
      subscription_end_date: expired_at,
      subscription_duration: subscription.duration,
      is_subscription_active: time_remaining > 0,
      ...additionalProps
    });
  };
};

export default useCombatSegmentAnalytics;
